import TextField from '@material-ui/core/TextField';
import Apis from "apis";
import commonStyle from 'assets/jss/common/common';
import Loading from 'components/Loading/Loading';
import { default as React, memo, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core'
import { useHistory } from 'react-router-dom';
import Button from 'components/CustomButtons/Button';
import { CallApi } from 'Utils/Request';
import { isMobile } from 'Utils/Dimension';
import { defaultStocks } from 'components/Header/SearchBox';
import Box from '@mui/material/Box'
import classNames from 'classnames';
import { Subject, debounceTime, switchMap, of } from 'rxjs';
import { useDispatch, useSelector } from 'react-redux';
import { saveCompanySearchTxt } from 'redux/reducers/formdata'
import { RootState } from 'redux/store';

const useStyles = makeStyles((theme) => ({
    input: {
        marginTop: 5
    },

    floatingLabelFocusStyle: {
        background: 'white',
    },
    ticker: {
        color: commonStyle.grayColor
    },
    companyName: {
        color: commonStyle.black,
        fontWeight: 'bold',
        '&:hover': {
            color: `${commonStyle.infoColor} !important;`
        },
    },
    stockListContainer: {
        maxHeight: isMobile ? 'none' : '50vh',
        minHeight: '20rem'
    },
    companyItem: {
        paddingLeft: '1rem',
        paddingRight: '1rem',
        cursor: 'pointer',
    },
    borderItem: {
        borderBottom: '0.1px dashed',
    }
}));

const searchSubject = new Subject()

function SearchCompany(props) {

    const { onClickCompany } = props
    const formdata = useSelector((state: RootState) => state.formdata)
    const oldSearchTxt = formdata.company_search_txt
    const [searchWord, setSearchWord] = useState('')
    const [data, setData] = useState(defaultStocks)
    const limit = 10
    const [loading, setLoading] = useState(false)
    const classes = useStyles()
    const history = useHistory()
    const dispatch = useDispatch()

    useEffect(() => {

        const sub = searchSubject.pipe(debounceTime(300), switchMap((next: string) => {
            if (next.length > 0) {
                setLoading(true)
                dispatch(saveCompanySearchTxt(next))
                return CallApi({
                    url: 'stocks',
                    params: {
                        search_by: next
                    }
                })
            } else {
                return Promise.resolve({ data: defaultStocks })
            }
        })).subscribe({
            next: (res: any) => {
                setLoading(false)

                if (res) {
                    setData(res.data)
                } else {
                    setData([])
                }
            },
            error: (e) => {
                setLoading(false)
                console.error(e)
            },
            complete: () => {
                console.info('complete')
                setLoading(false)
            }
        })

        setSearchWord(oldSearchTxt)
        searchSubject.next(oldSearchTxt)
        return () => {
            sub.unsubscribe()
        }
    }, [])

    return <div >
        <div style={{ display: 'flex', padding: '0.5rem', alignItems: 'center' }}>

            <TextField
                classes={{
                    root: classes.input, // class name, e.g. `classes-nesting-label-x`
                }}
                fullWidth
                placeholder="Search by ticker or company name"
                id='company'
                defaultValue=""
                variant="outlined"
                size="small"
                onChange={(e) => {
                    setSearchWord(e.target.value)
                    searchSubject.next(e.target.value)
                }}
                InputLabelProps={{
                    className: classes.floatingLabelFocusStyle,
                }}
                value={searchWord}
            />
            <Button size='sm' simple color='info' onClick={() => props.onClose()}>Cancel</Button>
        </div>
        <Box>
            <Loading isLoading={loading} />
            <div className={classes.stockListContainer}>
                {
                    data.map((item, key) => {
                        const companyItemClasses = classNames({
                            [classes.companyItem]: true,
                            [classes.borderItem]: key < (data.length - 1),
                        })
                        return <div key={key} className={companyItemClasses}>
                            <div className={classes.ticker}>{item.ticker}</div>
                            <div className={classes.companyName} onClick={() => onClickCompany(item)} >{item.name}</div>
                        </div>
                    })
                }
                {
                    data.length < 1 && <div className={classes.companyItem}>No result.</div>
                }
            </div>

        </Box>

    </div >;
}

SearchCompany.defaultProps = {
    onClickCompany: () => { },
    onClose: () => { }
}
export default (memo(SearchCompany))